<template>
  <span>
    <b v-if="stopped">{{ select }}</b>
    <b v-else>{{ number }}</b>
  </span>
</template>
<script>
export default {
  name: 'SlotNumber',
  props: {
    select: {
      type: [Number, String],
      default: null
    },
    timeout: {
      type: Number,
      default: 10
    },
    start: {
      type: Number,
      default: null
    }
  },
  data() {
    return {
      stopped: false,
      Interval: null,
      setTimeout: null,
      number: ''
    }
  },
  computed: {

  },
  methods: {
    spinning() {
      let running = this.start
      clearInterval(this.Interval)
      this.Interval = setInterval(() => {
        running++;
        this.number = running % 10
      }, 100);
    },
    timeoutToShow(timeout) {
      this.setTimeout = setTimeout(()=>{
        if(this.select) {
          // ถ้ามีค่าให้หยุดหมุด แล้วแสดงตัวเลข
          this.stopped = true
          clearInterval(this.Interval)
        }else{
          // ถ้าไม่มีค่าให้หมุนต่อ
          this.timeoutToShow(1000)
        }
      }, timeout)
    }
  },
  mounted() {
    this.spinning()
    /*this.setTimeout = setTimeout(()=>{
      this.stopped = true
      clearInterval(this.Interval)
    }, this.timeout)*/
    this.timeoutToShow(this.timeout)
  },
  beforeDestroy() {
    clearInterval(this.Interval)
    clearTimeout(this.setTimeout)
  }
}
</script>
